import React, { FC, useEffect, useState } from 'react';
import { Space } from 'antd';
import { AttributeTemplate } from '../../../../api/template';
import { ActionType } from '../index';
import TemplateModal from './TemplateModal';
import styles from './index.module.scss';
import { Button, Modal } from '@maxtropy/components';

export interface SelectDevicesProps {
  value?: AttributeTemplate;
  onChange?: (value?: AttributeTemplate) => void;
  deviceType?: number[];
  physicalModelId?: number;
  actionType?: ActionType;
}

const SelectDevices: FC<SelectDevicesProps> = ({ value, onChange, deviceType, actionType, physicalModelId }) => {
  const [visible, setVisible] = useState<boolean>(false);

  const [dataSource, setDataSource] = useState<AttributeTemplate>();

  useEffect(() => {
    setDataSource(value);
  }, [value]);

  const onAdd = () => {
    if (deviceType === undefined) {
      Modal.warning({
        title: '请先选择所属类目',
      });
      return;
    }
    setVisible(true);
  };

  const onCancel = () => {
    setDataSource(value);
    setVisible(false);
  };

  const onOk = () => {
    onChange?.(dataSource);
    setVisible(false);
  };

  return (
    <>
      <Space>
        {value !== undefined && <span>{value?.name ?? ''}</span>}
        <Button style={{ padding: 0 }} type="link" onClick={onAdd}>
          {value === undefined ? '请' : '重新'}选择
        </Button>
      </Space>
      <Modal
        className={styles.modal}
        title="模板选择"
        destroyOnClose
        open={visible}
        onOk={onOk}
        onCancel={onCancel}
        size="big"
      >
        <TemplateModal
          physicalModelId={physicalModelId}
          deviceType={deviceType}
          actionType={actionType}
          onChange={setDataSource}
          value={dataSource}
        />
      </Modal>
    </>
  );
};

export default SelectDevices;
